<template>
  <footer class="site-footer">
    <div class="site-footer__content">
      <div class="footer-top">
        <div class="footer-brand">
          <router-link to="/" class="footer-logo" aria-label="Home">
            <img
              v-if="siteConfig.logoUrl && !logoFailed"
              :src="siteConfig.logoUrl"
              :alt="siteConfig.siteName || '网站 Logo'"
              @error="logoFailed = true"
            >
          <span v-else>{{ siteConfig.siteName || '' }}</span>
          </router-link>
          <p>{{ $store.getters.t('footerTagline') }}</p>
        </div>

        <nav class="social-links" aria-label="Social media">
          <a v-if="instagramUrl" :href="instagramUrl" target="_blank" rel="noopener" aria-label="Instagram">
            <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle class="social-dot" cx="17.3" cy="6.8" r="1.1"/></svg>
          </a>
          <a v-if="facebookUrl" :href="facebookUrl" target="_blank" rel="noopener" aria-label="Facebook">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M13.8 21v-8h2.7l.4-3.1h-3.1V8c0-.9.3-1.5 1.6-1.5H17V3.7c-.4-.1-1.3-.2-2.4-.2-2.4 0-4 1.5-4 4.1v2.3H8v3.1h2.6v8h3.2Z"/></svg>
          </a>
          <a v-if="youtubeUrl" :href="youtubeUrl" target="_blank" rel="noopener" aria-label="YouTube">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M21.5 7.1a2.8 2.8 0 0 0-2-2C17.8 4.6 12 4.6 12 4.6s-5.8 0-7.5.5a2.8 2.8 0 0 0-2 2A29 29 0 0 0 2 12a29 29 0 0 0 .5 4.9 2.8 2.8 0 0 0 2 2c1.7.5 7.5.5 7.5.5s5.8 0 7.5-.5a2.8 2.8 0 0 0 2-2A29 29 0 0 0 22 12a29 29 0 0 0-.5-4.9ZM10 15.2V8.8l5.5 3.2-5.5 3.2Z"/></svg>
          </a>
          <a
            v-if="tiktokUrl"
            :href="tiktokUrl"
            target="_blank"
            rel="noopener"
            aria-label="TikTok"
          >
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/></svg>
          </a>
        </nav>
      </div>

      <p class="footer-copyright">{{ copyright }}</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data () {
    return { logoFailed: false }
  },
  computed: {
    siteConfig () { return this.$store.state.siteConfig },
    instagramUrl () { return this.normalizeExternalUrl(this.siteConfig.instagramUrl) },
    facebookUrl () { return this.normalizeExternalUrl(this.siteConfig.facebookUrl) },
    youtubeUrl () { return this.normalizeExternalUrl(this.siteConfig.youtubeUrl) },
    tiktokUrl () {
      return this.normalizeExternalUrl(this.siteConfig.tiktokUrl || this.siteConfig.youtubeUrl) || 'https://www.tiktok.com/'
    },
    copyright () { return this.siteConfig.footerCopyright || '2025 BECANE. All Rights Reserved.' }
  },
  watch: {
    'siteConfig.logoUrl' () {
      this.logoFailed = false
    }
  },
  methods: {
    normalizeExternalUrl (value) {
      const url = String(value || '').trim()
      if (!url) return ''
      return /^https?:\/\//i.test(url) ? url : `https://${url}`
    }
  }
}
</script>

<style scoped>
.site-footer {
  height: 160px;
  min-height: 160px;
  padding: 0;
  background: #000;
  color: #fff;
}

.site-footer__content {
  position: relative;
  width: 100%;
  height: 100%;
}

.footer-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  height: 115px;
  padding-top: 34px;
  border-bottom: 1px solid rgba(255, 255, 255, .04);
}

.footer-brand {
  min-width: 0;
  margin-left: 360px;
}

.footer-logo {
  display: flex;
  align-items: center;
  width: 170px;
  height: 30px;
  color: #fff;
}

.footer-logo img {
  display: block;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  object-position: left center;
}

.footer-logo span {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-style: italic;
  font-weight: 900;
  line-height: 1;
  letter-spacing: 0;
  transform: scaleX(.82);
  transform-origin: left center;
}

.footer-brand p {
  margin: 8px 0 0;
  color: rgba(255, 255, 255, .5);
  font-family: "PingFang SC", Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
}

.social-links {
  display: flex;
  align-items: center;
  width: 256px;
  height: 32px;
  justify-content: space-between;
  margin-right: 360px;
}

.social-links a {
  display: grid;
  width: 32px;
  height: 32px;
  place-items: center;
  color: #fff;
  /* 与站内其它可点击元素一致的悬停 / 点击反馈 */
  transition: color 0.18s ease, transform 0.18s ease;
}
@media (hover: hover) and (pointer: fine) {
  .social-links a:hover:not(:active) {
    color: var(--red);
    transform: translateY(-2px) scale(1.06);
  }
}
.social-links a:active {
  color: var(--red);
  transform: scale(0.94);
}
.social-links a:focus-visible {
  outline: 2px solid var(--red);
  outline-offset: 4px;
}

.social-links svg {
  width: 26px;
  height: 26px;
  fill: currentColor;
}

.social-icon-image {
  display: block;
  height: 26px;
  object-fit: contain;
  width: 26px;
}

.social-links rect,
.social-links circle { fill: none; stroke: currentColor; stroke-width: 2; }
.social-links .social-dot { fill: currentColor; stroke: none; }

.footer-copyright {
  position: absolute;
  top: 126px;
  right: 0;
  left: 0;
  height: 18px;
  margin: 0;
  color: rgba(255, 255, 255, .5);
  text-align: center;
  font-family: "PingFang SC", Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  text-transform: capitalize;
}

@media (max-width: 768px) {
  .site-footer {
    height: 176px;
    min-height: 176px;
  }

  .site-footer__content { padding: 0; }
  .footer-brand {
    position: absolute;
    top: 30px;
    right: 0;
    left: 0;
    margin: 0;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 36px;
    color: #fff;
    opacity: 1;
    text-align: center;
  }

  .footer-top {
    height: 128px;
    min-height: 128px;
    padding: 0;
  }

  .footer-logo {
    width: 120px;
    height: 28px;
    margin: 0 auto;
    flex: 0 0 28px;
    visibility: visible;
  }

  .footer-logo img {
    width: 100%;
    height: 100%;
  }

  .footer-logo span {
    font-size: 14px;
  }

  .footer-brand p {
    margin-top: 10px;
    display: block;
    white-space: nowrap;
    font-size: 13px;
    visibility: visible;
  }

  .social-links {
    position: absolute;
    /* 上方说明文字（68..83）与下方版权（126..139）之间取中，上下都留出间隔 */
    top: 92px;
    left: 50%;
    width: 244px;
    height: 28px;
    justify-content: space-between;
    gap: 0;
    margin-right: 0;
    transform: translateX(-50%);
  }
  .social-links a {
    width: 28px;
    height: 28px;
    color: #fff;
  }
  .social-links svg { width: 22px; height: 22px; }
  .social-icon-image { width: 22px; height: 22px; }
  .footer-copyright {
    position: absolute;
    right: 0;
    bottom: 20px;
    left: 0;
    height: 13px;
    margin: 0;
    padding: 0;
    font-size: 10.4px;
    line-height: 13px;
  }
}
</style>
